const config = {
  api: {
    // base_url: "http://localhost:8183/",
    // base_url: "http://3.7.97.20:8183/",
    base_url: "https://lilac-doctor-dev-api.aiolos.solutions/",
  },
  dtrf: {
    // test: "v1/test/search",
    test: "test-master/get-dropdown-list",
    patient: "patient/on-dtrf-search",
    validateContainerUrl: "emergency-dtrf/sample-validator",
    pincode: "v1/pincode/list",
    // validateContainerUrl:
    //   "emergency-dtrf/sample-validator",
    containers: "emergency-dtrf/get-dropdown-list-for-container",
    referral_doctor: "doctor-dtrf/search",
    flow: "test-master/flow",
    gestationalAge: "test/gestational_age",
    payment: "test-master/pricing",
    // submit: "v1/dtrf/save",
    submit:"doctor-dtrf/submit-doctor-dtrf",
    gestationalAge:"doctor-dtrf/gestational-age",
    getDtrfs:"doctor-dtrf",
    viewDtrf:"doctor-dtrf/get"
  },
  jitsi_meet_domian:"jitsi-demo.aiolos.solutions",
};
if (process.env.REACT_APP_ENV === "dev") {
  config.api.base_url = "https://lilac-doctor-dev-api.aiolos.solutions/";
  // config.api.base_url = "http://3.7.97.20:8183/";
}
Object.keys(config.dtrf).map((key) => {
  config.dtrf[key] = config.api.base_url + config.dtrf[key];
});
// config.dtrf.submit = "http://localhost:8183/doctor-dtrf/submit-doctor-dtrf";
export default config;
